export default __webpack_public_path__ + "static/33905-e7c5388dbf53724d80bc331502ef9c44.jpg";